import React from 'react';

const IconLoader = () => (
  <svg
    id="logo"
    xmlns="http://www.w3.org/2000/svg"
    width="850"
    height="240"
    viewBox="266.7410708630965 48.374436332683516 157.4253062769945 70.42837208118786">
    <title>Loader Logo</title>
    <g>
      <g id="underscore">
        <path
          stroke="#5363c1"
          strokeWidth="0"
          strokeDasharray="none"
          strokeLinecap="butt"
          strokeDashoffset="0"
          strokeLinejoin="miter"
          strokeMiterlimit="4"
          fill="#000"
          fillRule="nonzero"
          opacity="1"
          d="M0-27.902c15.402 0 27.902 12.5 27.902 27.902 0 15.402-12.5 27.902-27.902 27.902-15.402 0-27.902-12.5-27.902-27.902 0-15.402 12.5-27.902 27.902-27.902z"
          transform="translate(311.392 83.589) scale(.94146)"
        />
        <path
          stroke="#5363c1"
          strokeWidth="0"
          strokeDasharray="none"
          strokeLinecap="butt"
          strokeDashoffset="0"
          strokeLinejoin="miter"
          strokeMiterlimit="4"
          fill="#000"
          fillRule="nonzero"
          opacity="1"
          d="M0-27.902c15.402 0 27.902 12.5 27.902 27.902 0 15.402-12.5 27.902-27.902 27.902-15.402 0-27.902-12.5-27.902-27.902 0-15.402 12.5-27.902 27.902-27.902z"
          transform="translate(384.766 83.589) scale(.94146)"
        />
      </g>
      <path
        stroke="#fadb39"
        strokeWidth="41"
        strokeDasharray="none"
        strokeLinecap="round"
        strokeDashoffset="0"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        fill="#fadb39"
        fillRule="nonzero"
        opacity=".77"
        transform="matrix(1.3211 0 0 1.13185 215.703 -64.83)"
        d="M59.133 141.741h2.809q1.116 0 4.464-.558 3.348-.558 7.813-1.953 4.464-1.395 7.533-1.953 3.07-.558 6.139-1.395 3.069-.837 6.138-1.953 3.07-1.117 5.86-1.954 2.79-.837 6.417-1.953t5.86-1.674q2.231-.558 3.905-1.395 1.675-.837 6.418-2.232 4.743-1.395 5.301-1.395.558 0 1.395-.28.837-.278 1.953-.557 1.116-.28 1.674-.558.559-.28 1.117-.28.558 0 1.116-.278.558-.28.837-.28h.558q.279 0 .558-.278l.298-.298"
      />
    </g>
  </svg>
);

export default IconLoader;
